<template>
  <div>
    <b-table
      hover
      small
      head-variant="dark"
      :items="files"
      :fields="fields">
      <template v-slot:cell(index)="data">
        {{data.index + 1}}
      </template>
      <template v-slot:cell(rowCount)="data">
        {{data.value | formatInt}}
      </template>
      <template v-slot:cell(createdAt)="data">
        {{data.value | humanize}}
      </template>
      <template v-slot:cell(isActive)="data">
        <div class="text-right" style="min-width: 110px;">
          <i
            class="fa fa-check text-success mr-3"
            v-if="data.value"/>
          <b-button
            v-else
            variant="outline-primary"
            size="sm"
            class="px-3"
            @click="() => handlePick(data.item.id)">
            pick
          </b-button>

          <b-button
            variant="outline-danger"
            size="sm"
            class="px-2 mr-1"
            @click="() => onDelete(data.item.id)">
            <i class="fa fa-trash-o"/>
          </b-button>

        </div>
      </template>
    </b-table>

    <confirm-delete
      v-if="deleteFileID"
      :key="deleteFileID"
      :fileID="deleteFileID"
      @close="deleteFileID = null"/>
  </div>
</template>

<script>
	import _ from 'lodash';
	import ConfirmDelete from './ConfirmDelete';

	export default {
		name: 'FilePicker',
		components: {ConfirmDelete},
		props: {
			type: String,
			project: Object
		},
		data() {
			return {
				isSaving: false,
				activeID: this.$store.state.files.activeMap[this.type] || null,
				deleteFileID: null
			};
		},

		computed: {
			files() {
				// const files = this.$store.state.files.fileList
				// 	.filter(({type}) => type === this.type)
				// 	.map(file => {
				// 		const isActive = this.activeID === file.id;

				// 		return {
				// 			...file,
				// 			isActive,
				// 		};
				// 	});

				// return _.reverse(_.sortBy(files, ({createdAt}) => new Date(createdAt)));
				const files = this.$store.state.files.fileList
					.map(file => {
						const isActive = false;
						return {
							...file,
							isActive,
						};
					});

				return _.reverse(_.sortBy(files, ({createdAt}) => new Date(createdAt)));
			},

			fields() {
				return [
					{key: 'index', label: '#'},
					{key: 'originalName', label: 'Name'},
					{key: 'rowCount', label: 'Rows'},
					{key: 'createdAt', label: 'Created'},
					{key: 'isActive', label: ''},
				];
			},
		},

		methods: {
			handlePick(fileID) {
				this.$emit('pick', fileID);
			},

			onDelete(fileID) {
				this.deleteFileID = fileID;
			}
		}
	};
</script>

<style scoped>

</style>
